export default "__VITE_ASSET__BfwlqmnZ__"